const updateDocumentTitle = (title: string) => {
    document.title = title
}
export default updateDocumentTitle
